import React from "react";
import { Check, X } from "lucide-react";

/**
 * Politique de complexité - DOIT correspondre à validate_password_strength
 * dans /app/backend/core/security.py
 */
export const PASSWORD_RULES = [
  { key: "length", label: "12 caractères minimum", test: (p) => p.length >= 12 },
  { key: "lower", label: "Au moins une minuscule (a-z)", test: (p) => /[a-z]/.test(p) },
  { key: "upper", label: "Au moins une majuscule (A-Z)", test: (p) => /[A-Z]/.test(p) },
  { key: "digit", label: "Au moins un chiffre (0-9)", test: (p) => /\d/.test(p) },
  { key: "symbol", label: "Au moins un caractère spécial (!@#$%&*…)", test: (p) => /[!@#$%^&*()_+\-=[\]{};':",./<>?|`~\\]/.test(p) },
];

export function isPasswordStrong(password) {
  return PASSWORD_RULES.every((r) => r.test(password));
}

export default function PasswordRulesChecklist({ password = "", className = "" }) {
  return (
    <ul
      className={`space-y-1 text-xs ${className}`}
      data-testid="password-rules-checklist"
    >
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.key}
            className={`flex items-center gap-2 ${ok ? "text-emerald-700" : "text-zinc-500"}`}
            data-testid={`password-rule-${rule.key}-${ok ? "ok" : "ko"}`}
          >
            {ok ? (
              <Check size={12} className="text-emerald-600" />
            ) : (
              <X size={12} className="text-zinc-400" />
            )}
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
